import db from '@/firebase/init';
import { doc, onSnapshot } from 'firebase/firestore';
import { getUserInfoFromStorage } from '@/utils/saveDataToLocal';

const COLLECTION = 'notification-triggers';

export const listenNotifications = (onUpdate) => {
  const user = getUserInfoFromStorage();
  const userId = user && (user.userId || user.id);

  if (!userId) {
    return () => {};
  }

  const ref = doc(db, COLLECTION, String(userId));

  const unsubscribe = onSnapshot(
    ref,
    (snap) => {
      if (snap.exists()) onUpdate();
    },
    (err) => {
      console.error('[NotificationListener] onSnapshot error:', err.code, err.message);
    },
  );

  return unsubscribe;
};
